import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import RegisterModalOptions from "./RegisterModalOptions";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "500",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  paddingTop: 1,
  paddingLeft: 3,
  paddingRight: 3,
  paddingBottom: 3,
  borderRadius: "10px",
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 300,
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 300,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 5,
    overflow: "hidden",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  fieldContainer: {
    display: "flex",
    marginBottom: "12px",
    alignItems: "center",
  },
 
  submitButton: {
    textTransform: "none",
    marginLeft: "70%",
  },
  label: {
    fontWeight: "bold",
  },
  imageStyle: {
    maxWidth: "100%",
    maxHeight: "100%",
    border: "1px solid #000",
    borderRadius: "10px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    marginRight: "7%",
    marginTop: "20px",
  },
}));

export default function MyStagedDeviceForm() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setKey("");
  };
  const classes = useStyles();

  const [port, setPort] = useState(localStorage.getItem("port") || "");
  const [host, setHost] = useState(localStorage.getItem("host") || "");
  const [key, setKey] = useState("");
  const currapikey = useSelector((state) => state.currapikey);

  useEffect(() => {
    const api = localStorage.getItem("api");
    if (api) {
      const url = new URL(api);
      setHost(url.protocol + url.hostname);
      setPort(url.port);
    }
  }, []);
  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "120px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
    <div>
      <Button
        style={{ textTransform: "none" }}
        variant="contained"
        color="primary"
        onClick={handleOpen}
      >
        Register Device
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            <h2>Elhi Devices </h2>
          </div>
          <br />
          <div>
            <div>
              <div>
                Start with EECP or Manual configuration with the below details.
                Choose an API key for letting the device to ELM.
              </div>
              <div className={classes.fieldContainer}>
                {getLabelWithAsterisk("Your API key:", true)}

                <RegisterModalOptions />
              </div>
            </div>

            <div>
              {getLabelWithAsterisk("Configuration  ", false)}
              <div className={classes.fieldContainer}>
                {getLabelWithAsterisk("ELM Host:", true)}
                <TextField
                  style={{width:"35ch"}}
                  label="Host"
                  size="small"
                  value={host}
                  onChange={(e) => setHost(e.target.value)}
                  variant="outlined"
                />
              </div>

              <div className={classes.fieldContainer}>
                {getLabelWithAsterisk("ELM Port:", true)}
                <TextField
                  label="Port"
                  style={{width:"35ch"}}
                  size="small"
                  value={port}
                  onChange={(e) => setPort(e.target.value)}
                  variant="outlined"
                />
              </div>

              <div className={classes.fieldContainer}>
                {getLabelWithAsterisk("Key:", true)}
                <TextField
                 style={{width:"35ch"}}
                  value={currapikey?.currapikey}
                  disabled
                  onChange={(e) => setKey(e.target.value)}
                  variant="outlined"
                  size="small"
                />
              </div>
            </div>
          </div>

          <Button
            style={{ textTransform: "none" }}
            variant="contained"
            color="primary"
            onClick={handleClose}
          >
            Okay
          </Button>
        </Box>
      </Modal>
    </div>
  );
}
